import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import Button from '../../../../../new-components/ui/Button';

const GetOfferButton = (): JSX.Element => {
  const { t } = useTranslation('entity');

  return (
    <GetOfferButtonContainer>
      <Button
        text={t('get_offer')}
        backgroundColor="#FFFFFF"
        color="#EB9E48"
        fontSize="14px"
        padding="0px, 8px, 0px, 8px"
        border="1px solid #EB9E48"
        containerClass="action-btn"
        onClick={() => {}}
      />
    </GetOfferButtonContainer>
  );
};

const GetOfferButtonContainer = styled.div`
  button {
    height: 44px;
    width: 200px;
    color: #eb9e48;
    border-radius: 8px;
    font-family: materialBold;
  }
`;

export default GetOfferButton;
